var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMySurveysActive = function SvgMySurveysActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    transform: "translate(7.5 10.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.75,
    cy: 0.75,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 1.5,
    x: 4,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.75,
    cy: 4.75,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 1.5,
    x: 4,
    y: 4,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.75,
    cy: 8.75,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 1.5,
    x: 4,
    y: 8,
    rx: 0.75
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMySurveysActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/my-surveys-active.7408ef83cad36363fe3965a988021c15.svg";